import { Subscription as RecurlySubscription } from "@recurly/react-recurly";
import {
	AccountSubscriptionPaidConfig,
	SUBSCRIPTION_CYCLE,
	SUBSCRIPTION_PLAN,
} from "~utils/types/__generated/gql/graphql";

export const getRecurlyAddons = (
	values: AccountSubscriptionPaidConfig,
): RecurlySubscription["addons"] => {
	const { plan: planFormValue, cycle, addons: addonsFormValue } = values;
	if (planFormValue === SUBSCRIPTION_PLAN.BUSINESS) return [];

	return Object.keys(addonsFormValue).reduce(
		(pre, key) => {
			if (!addonsFormValue[key]) return pre;

			let addonTypeCode = "";
			switch (key) {
				case "admins":
					addonTypeCode = "1222";
					break;
				case "editors":
					addonTypeCode = "1333";
					break;
				case "storage":
					addonTypeCode = "1444";
					break;
				case "maps":
					addonTypeCode = "1555";
					break;
			}

			let planCode = "";
			switch (planFormValue) {
				case SUBSCRIPTION_PLAN.ENTERPRISE:
					planCode = "00";
					break;
				case SUBSCRIPTION_PLAN.AGENCY:
					planCode = "10";
					break;
			}

			let cycleCode = "";
			switch (cycle) {
				case SUBSCRIPTION_CYCLE.MONTHLY:
					cycleCode = "0";
					break;
				case SUBSCRIPTION_CYCLE.ANNUAL:
					cycleCode = "1";
					break;
				case SUBSCRIPTION_CYCLE.TWO_YEARS:
					cycleCode = "2";
					break;
				case SUBSCRIPTION_CYCLE.THREE_YEARS:
					cycleCode = "3";
					break;
				case SUBSCRIPTION_CYCLE.FOUR_YEARS:
					cycleCode = "4";
					break;
				case SUBSCRIPTION_CYCLE.FIVE_YEARS:
					cycleCode = "5";
					break;
			}

			return [
				...(pre ?? []),
				{
					code: `${addonTypeCode}${planCode}${cycleCode}`,
					quantity: addonsFormValue[key],
				},
			];
		},
		[] as RecurlySubscription["addons"],
	);
};
